import { generateClassName } from '@klv/shared/utils/functions';
import Typography from '@klv/atoms/typography';
import FadeInUp from '@klv/utils/fade-in-up';

import * as styles from './styles/fullColumnTextCta.module.scss';

import type { IFullColumnTextCta } from './types';
import Buttons from '@klv/molecules/buttons';

export const FullColumnTextCta = ({
  className = '',
  backgroundColor = 'light',
  buttons,
  customPadding = { customPaddingBottom: 'default', customPaddingTop: 'default' },
  headline,
}: IFullColumnTextCta) =>  (
  <div className={generateClassName([className,
    styles.fullColumnTextCta,
    styles[backgroundColor],
    `${customPadding.customPaddingBottom}PaddingBottom`,
    `${customPadding.customPaddingTop}PaddingTop`,
  ])}
    >
    <FadeInUp>
      <div className="grid">
        {headline && (
          <Typography
            className={styles.styledHeadline}
            as='h2'
            variant='h2'
            dangerouslySetInnerHTML={{ __html: headline }}
          />
        )}
        {buttons && (
          <Buttons
            buttonColor={backgroundColor === 'dark' ? 'light' : 'dark'}
            className={styles.styledButtons}
            variants={['ghost']}
            buttons={buttons}
        />)}
      </div>
    </FadeInUp>
  </div>
);

